<template>
  <div class="login-page">
    <div class="background-image"></div>
    <UserAgreement v-show="showAgreementModal" @close="closeAgreement" @agreementAccepted="handleAgreementAccepted" />
    <div class="login-panel">
      <div class="left-panel">
        <!-- Image goes here -->
      </div>
      <div v-show=ifLogin class="right-panel">
        <h2>登陆</h2>
        <form>
          <div class="form-group">
            <label for="username">账户</label>
            <input type="text" v-model="username" />
          </div>
          <div class="form-group">
            <label for="password">密码</label>
            <input type="password" v-model="password" />
          </div>
          <div class="agreement">
            <input type="checkbox" id="agreement" v-model="agreementAccepted" />
            <label for="agreement">我已阅读并同意</label>
            <a @click="showUserAgreement" href="javascript:void(0)">《用户协议》</a>
          </div>
          <div class="login-button">
            <button @click="handleLogin">登陆</button>
          </div>
        </form>
        <div class="other-options">
          <div class="other-options">
            <button @click="convertRegister">创建用户</button>
            <button @click="convertModifyPassword">修改密码</button>
          </div>
        </div>
      </div>
      <div v-show=ifRegister class="right-panel">
        <h2>注册新用户</h2>
        <form>
          <div class="form-group">
            <label for="username">账户</label>
            <input type="text" id="username" v-model="username" />
          </div>
          <div class="form-group">
            <label for="password">新密码</label>
            <input type="password"  v-model="password"/>
          </div>
          <div class="form-group">
            <label for="password">确认密码</label>
            <input type="password" v-model="verifyPassword"/>
          </div>
          <div class="login-button">
            <button @click="handleRegister">确定</button>
          </div>
        </form>
        <div class="other-options">
            <button @click="convertLogin">返回登陆</button>
        </div>
      </div>
      <div v-show=ifModifyPassword class="right-panel">
        <h2>修改密码</h2>
        <form>
          <div class="form-group">
            <label for="username">账户</label>
            <input type="text" v-model="username" />
          </div>
          <div class="form-group">
            <label for="password">旧密码</label>
            <input type="password" v-model="password" />
          </div>
          <div class="form-group">
            <label for="password">新密码</label>
            <input type="password" v-model="newPassword" />
          </div>
          <div class="login-button">
            <button @click="handleModifyPassword">确定</button>
          </div>
        </form>
        <div class="other-options">
            <button @click="convertLogin">返回登陆</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { register, login ,changePassword} from '@/api/auth';
import UserAgreement from './UserAgreement.vue';
export default {
  components: {
    UserAgreement
  },
  data() {
    return {
      username: '',
      password: '',
      verifyPassword: '',
      newPassword: '',
      ifLogin: true,
      ifRegister: false,
      ifModifyPassword: false,
      agreementAccepted: false,
      showAgreementModal: false
    };
  },
  methods: {
    showUserAgreement() {
      // 显示用户协议模态框
      this.showAgreementModal = true;
    },
    closeAgreement() {
      // 关闭用户协议模态框
      this.showAgreementModal = false;
    },
    handleAgreementAccepted() {
      // 处理用户同意协议
      this.agreementAccepted = true;
      this.showAgreementModal = false;
    },
    sendpassword() {
      // Send password code logic goes here
    },
    convertLogin() {
      // Login logic goes here
      this.ifLogin=true;
      this.ifRegister=false;
      this.ifModifyPassword=false;
    },
    convertRegister() {
      // Register logic goes here
      this.ifLogin=false;
      this.ifRegister=true;
      this.ifModifyPassword=false;
    },
    convertModifyPassword() {
      // Modify password logic goes here
      this.ifLogin=false;
      this.ifRegister=false;
      this.ifModifyPassword=true;
    },
    async handleRegister(e) {
      e.preventDefault();
      if (this.password !== this.verifyPassword) {
        alert('两次输入密码不一致');
        return;
      }
      if (!this.agreementAccepted) {
        alert('请先阅读并同意用户协议');
        return;
      }
      register(this.username, this.password).then((data) => {
        console.log('注册成功:', data);
        alert('注册成功!');
        this.$emit('setShowLogin',false);
        setTimeout(() => {
          this.convertLogin();//注册成功后自动转到登陆页面
        }, 1000);
       
      }).catch((error) => {
        console.error('注册失败:', error);
        console.log('报错信息:', error.response.data.detail);
        switch (error.response.data.detail) {
          case '用户名已存在':
            console.log('用户名已存在:', error);
            alert('用户名已存在');
            break;
          case '用户名和密码不能为空':
            console.log('用户名和密码不能为空:', error);
            alert('用户名和密码不能为空');
            break;
          // Add more cases here if needed
        }
      });      
    },
    async handleLogin(e) {
      e.preventDefault();
      if (!this.agreementAccepted) {
        alert('请先阅读并同意用户协议');
        return;
      }
      login(this.username, this.password).then((data) => {
        console.log('登陆返回信息:', data);
        this.$emit('setShowLogin',false);
        this.$store.commit('setShowLogin', false);
        this.$store.commit('setUserId', data.user_id);
        this.$store.commit('setUsername', this.username);
        this.$store.commit('setLoginStatus', true);
      }).catch((error) => {
        console.error('登陆失败:', error);
        console.log('报错信息:', error.response.data.detail);
        switch (error.response.data.detail) {
          case '用户名或密码错误':
            console.log('用户名或密码错误:', error);
            alert('用户名或密码错误');
            break;
          case '用户名或密码不能为空':
            console.log('用户名和密码不能为空:', error);
            alert('用户名和密码不能为空');
            break;
          // Add more cases here if needed
        }
      });
        
    },
    async handleModifyPassword(e) {
      e.preventDefault();
      changePassword(this.username, this.password, this.newPassword).then((data) => {
        console.log('修改密码成功:', data);
        alert('修改密码成功!');
        this.$emit('setShowLogin',false);
        setTimeout(() => {
          this.convertLogin();//修改密码成功后自动转到登陆页面
        }, 1000);
      }).catch((error) => {
        console.error('修改密码失败:', error);
        console.log('报错信息:', error.response.data.detail);
        switch (error.response.data.detail) {
          case '用户未找到':
            console.log('用户未找到:', error);
            alert('用户未找到');
            break;
          case '旧密码错误':
            console.log('旧密码错误:', error);
            alert('旧密码错误');
            break;
          case '新密码或旧密码不能为空':
            console.log('新密码或旧密码不能为空:', error);
            alert('新密码或旧密码不能为空');
            break;
          // Add more cases here if needed
        }
      });


    }
      
  }
};
</script>

<style scoped>
.login-page {
  position: absolute;
  height: 100vh;
  width: 100vw;
  z-index: 10;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background:black;
  background-size: cover;
  opacity: 0.5;
}

.login-panel {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 735px;
  height: 683px;
  background-color: white;
  border-radius: 10px;
  display: flex;
}

.left-panel {
  flex: 1;
  background-image: url('../../assets/images/login/login-panel.png');
  background-size: cover;
}

.right-panel {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p{
    font-size: 16px;
    color: #7A97CF;
    font-family:'思源黑体 CN Regular';
  }
}
.agreement{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  #agreement{
    width: 20px;
    height: 20px;
    margin-right: 10px;  
  }
}
form {
  width: 100%;
  max-width: 300px;
  font-family:'思源黑体 CN Regular' ;
}

.form-group {
  margin-bottom: 20px;
  width:300px;
}
.password-input{
  display: flex;
    margin-right: 20px;
    border-radius: 5px;
  button{
    width: 150px;
    margin-right: -20px;
  }
}
.login-button{
  position: relative;
  left:0px;
  button{
    width: 312px;

  }
}

label {
  display: block;
  font-size: 16px;
  color: #BBBBBB;
}

input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

button {
  padding: 10px 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #0056b3;
}

.wechat-login {
  margin-top: 20px;
  text-align: center;
}
.other-options {
  display: flex;
  margin-top: 10px;
  justify-content: space-evenly;
  width: 200px;
  button{
    color:#007bff;
    background-color: rgba(255, 255, 255, 0);
  }
  button:hover{
    color:white;
    background-color: #007bff;
  }
  
}

@media (max-width: 768px) {
  .login-page {
    position: fixed;
    width: 100vw;
    height: 100vh;
    min-width: 0;
    min-height: 0;
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .background-image {
    background-size: cover;
    background-position: center;
    opacity: 0.6;
  }
  .login-panel {
    flex-direction: column;
    width: 90vw;
    max-width: 400px;
    min-width: 0;
    height: auto;
    min-height: 0;
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    border-radius: 10px;
    margin: 20px auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    background: white;
  }
  .left-panel {
    display: none;
  }
  .right-panel {
    flex: none;
    width: 100%;
    min-width: 0;
    padding: 30px 20px;
    box-sizing: border-box;
    border-radius: 10px;
    align-items: center;
  }
  form {
    max-width: 100%;
    width: 100%;
  }
  .form-group {
    width: 100%;
    margin-bottom: 16px;
  }
  .login-button button {
    width: 100%;
    font-size: 18px;
    padding: 12px 0;
  }
  .other-options {
    width: 100%;
    justify-content: space-between;
    gap: 10px;
  }
  .other-options button {
    width: 48%;
    font-size: 16px;
    padding: 10px 0;
  }
  label {
    font-size: 15px;
  }
  input {
    font-size: 16px;
    padding: 10px 8px;
  }
  .agreement {
    font-size: 13px;
    margin-bottom: 16px;
  }
  .agreement #agreement {
    width: 18px;
    height: 18px;
    margin-right: 6px;
  }
}
</style>
